import { IGetMapReportDefinitionResponse } from '../facility/i-facility';
import { IAction } from '../root/i-action';
import { IState } from '../root/state.interface';
import { IColumn } from './i-column';
import { IExecuteReport } from './i-execute-report';
import {
  IExecutedReport,
  IPreparedReport,
  IReport,
  IListsForReport,
  IReportQuickRange,
  IReportTree,
  IGetZonesForMapsResponse,
  IGetMapReportResponse,
  IMapControlsState,
} from './i-report';

export const getReportsListRequest = (state: IState): IState => ({
  ...state,
  reportsTree: {
    data: [],
    loading: true,
    error: undefined,
    loaded: false,
  },
});

export const getReportsListSuccess = (state: IState, action: IAction<IReportTree[]>): IState => ({
  ...state,
  reportsTree: {
    data: action.payload,
    loading: false,
    error: undefined,
    loaded: true,
  },
});

export const getReportsListFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  reportsTree: {
    data: [],
    loading: false,
    error: action.payload,
    loaded: false,
  },
});

export const getReportsRequest = (state: IState): IState => ({
  ...state,
  reports: {
    data: [],
    loading: true,
    error: undefined,
  },
});

export const getReportsSuccess = (state: IState, action: IAction<IReport[]>): IState => ({
  ...state,
  reports: {
    data: action.payload,
    loading: false,
    error: undefined,
  },
});

export const getReportsFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  reports: {
    data: [],
    loading: false,
    error: action.payload,
  },
});

export const prepareReportRequest = (state: IState): IState => ({
  ...state,
  preparedReport: {
    data: {
      execution_time_millis: 0,
      name: '',
    },
    loading: true,
    error: undefined,
    loaded: false,
  },
});

export const prepareReportSuccess = (state: IState, action: IAction<IPreparedReport>): IState => ({
  ...state,
  preparedReport: {
    data: action.payload,
    loading: false,
    error: undefined,
    loaded: true,
  },
});

export const prepareReportFailure = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  preparedReport: {
    data: {
      execution_time_millis: 0,
      name: '',
    },
    loading: false,
    error: action.payload,
    loaded: false,
  },
});

export const copyReportFailure = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  copiedReport: {
    data: {
      id: 0,
    },
    loading: false,
    error: action.payload,
    loaded: false,
  },
});

export const getReportRequest = (state: IState): IState => ({
  ...state,
  report: {
    data: {
      id: 0,
      reportGroup_id: null,
      code: '',
      name: '',
      tenant: '',
      collection: '',
      description: '',
      find: null,
      sort: null,
      aggregate: null,
    },
    loading: true,
    error: undefined,
    loaded: false,
  },
});

export const getReportSuccess = (state: IState, action: IAction<IReport>): IState => ({
  ...state,
  report: {
    data: action.payload,
    loading: false,
    error: undefined,
    loaded: true,
  },
});

export const getReportFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  report: {
    data: {
      id: 0,
      reportGroup_id: null,
      code: '',
      name: '',
      tenant: '',
      collection: '',
      description: '',
      find: null,
      sort: null,
      aggregate: null,
    },
    loading: false,
    error: action.payload,
    loaded: false,
  },
});

export const getExecutedReportRequest = (state: IState): IState => ({
  ...state,
  executedReport: {
    data: {
      ...state.executedReport.data,
    },
    loading: true,
    error: undefined,
    loaded: false,
  },
});

export const getExecutedReportSuccess = (
  state: IState,
  action: IAction<IExecutedReport>,
): IState => ({
  ...state,
  executedReport: {
    data: action.payload,
    loading: false,
    error: undefined,
    loaded: true,
  },
});

export const getExecutedReportFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  executedReport: {
    data: {
      id: 0,
      tenant: '',
      code: '',
      name: '',
      collection: '',
      description: '',
      columns: [],
      find: '',
      sort: '',
      aggregate: '',
    },
    loading: false,
    error: action.payload,
    loaded: false,
  },
});

export const resetExecutedReport = (state: IState): IState => ({
  ...state,
  executedReport: {
    data: {
      id: 0,
      tenant: '',
      code: '',
      name: '',
      collection: '',
      description: '',
      columns: [],
      find: '',
      sort: '',
      aggregate: '',
    },
    loading: false,
    error: '',
    loaded: false,
  },
});

export const getAllColumnsReportRequest = (state: IState): IState => ({
  ...state,
  allColumnsOfReport: {
    data: [],
    loading: true,
    error: undefined,
    loaded: false,
  },
});

export const getAllColumnsReportSuccess = (state: IState, action: IAction<string[]>): IState => ({
  ...state,
  allColumnsOfReport: {
    data: action.payload,
    loading: false,
    error: undefined,
    loaded: true,
  },
});

export const getAllColumnsReportFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  allColumnsOfReport: {
    data: [],
    loading: false,
    error: action.payload,
    loaded: false,
  },
});

export const getCollectionsForReportRequest = (state: IState): IState => ({
  ...state,
  reportCollections: {
    data: [],
    loading: true,
    error: undefined,
    loaded: false,
  },
});

export const getCollectionsForReportSuccess = (
  state: IState,
  action: IAction<string[]>,
): IState => ({
  ...state,
  reportCollections: {
    data: action.payload,
    loading: false,
    error: undefined,
    loaded: true,
  },
});

export const getCollectionsForReportFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  reportCollections: {
    data: [],
    loading: false,
    error: action.payload,
    loaded: false,
  },
});

export const executeReportRequest = (state: IState): IState => ({
  ...state,
  execReport: {
    data: {
      code: '',
      name: state.execReport.data.name,
      description: '',
      filter: '',
      sort: '',
      limit: state.execReport.data.limit || 10,
      skip: 0,
      count: state.execReport.data.count,
      fields: [],
      columnStyles: [],
      headers: [],
      records: [],
    },
    loading: true,
    error: undefined,
    loaded: false,
  },
});

export const executeReportSuccess = (state: IState, action: IAction<IExecuteReport>): IState => ({
  ...state,
  execReport: {
    data: action.payload,
    loading: false,
    error: undefined,
    loaded: true,
  },
});

export const executeReportFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  execReport: {
    data: {
      code: '',
      name: '',
      description: '',
      filter: '',
      sort: '',
      limit: 10,
      skip: 0,
      count: 10,
      fields: [],
      columnStyles: [],
      headers: [],
      records: [],
    },
    loading: false,
    error: action.payload,
    loaded: false,
  },
});

export const editColumnRequest = (state: IState): IState => ({
  ...state,
  columns: {
    data: state.columns.data,
    loading: true,
    error: undefined,
  },
});

export const editColumnSuccess = (state: IState, action: IAction<IColumn[]>): IState => ({
  ...state,
  columns: {
    data: action.payload,
    loading: false,
    error: undefined,
  },
});

export const editColumnFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  columns: {
    data: [],
    loading: false,
    error: action.payload,
  },
});

export const removeColumnRequest = (state: IState): IState => ({
  ...state,
  columns: {
    data: state.columns.data,
    loading: true,
    error: undefined,
  },
});

export const removeColumnSuccess = (state: IState, action: IAction<IColumn[]>): IState => ({
  ...state,
  columns: {
    data: action.payload,
    loading: false,
    error: undefined,
  },
});

export const removeColumnFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  columns: {
    data: [],
    loading: false,
    error: action.payload,
  },
});

export const getRegexRequest = (state: IState): IState => ({
  ...state,
  regex: {
    data: state.regex.data,
    loading: true,
    error: undefined,
  },
});

export const getRegexSuccess = (state: IState, action: IAction<string[]>): IState => ({
  ...state,
  regex: {
    data: action.payload,
    loading: false,
    error: undefined,
  },
});

export const getRegexFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  regex: {
    data: [],
    loading: false,
    error: action.payload,
  },
});

export const getReportQuickRangesRequest = (state: IState): IState => ({
  ...state,
  reportQuickRanges: {
    data: state.reportQuickRanges.data,
    loading: true,
    error: undefined,
  },
});

export const getReportQuickRangesSuccess = (
  state: IState, action: IAction<IReportQuickRange[]>,
): IState => ({
  ...state,
  reportQuickRanges: {
    data: action.payload,
    loading: false,
    error: undefined,
  },
});

export const getReportQuickRangesFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  reportQuickRanges: {
    data: [],
    loading: false,
    error: action.payload,
  },
});

export const getListsForReportRequest = (state: IState): IState => ({
  ...state,
  listsForReport: {
    data: state.listsForReport.data,
    loading: true,
    error: undefined,
  },
});

export const getListsForReportSuccess = (
  state: IState,
  action: IAction<IListsForReport>,
): IState => ({
  ...state,
  listsForReport: {
    data: action.payload,
    loading: false,
    error: undefined,
  },
});

export const getListsForReportFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  listsForReport: {
    data: {
      regex: [],
      quickRanges: [],
      operators: [],
      filterFields: [],
    },
    loading: false,
    error: action.payload,
  },
});

export const getReportSuggestionsRequest = (state: IState): IState => ({
  ...state,
  reportFieldSuggestions: {
    data: state.reportFieldSuggestions.data,
    loading: true,
    error: undefined,
  },
});

export const getReportSuggestionsSuccess = (
  state: IState,
  action: IAction<{ fieldName: string, data: [] }>,
): IState => ({
  ...state,
  reportFieldSuggestions: {
    data: {
      ...state.reportFieldSuggestions.data,
      [action.payload.fieldName]: action.payload.data,
    },
    loading: false,
    error: undefined,
  },
});

export const getReportSuggestionsFail = (
  state: IState,
  action: IAction<Error>,
): IState => ({
  ...state,
  reportFieldSuggestions: {
    ...state.reportFieldSuggestions,
    loading: false,
    error: action.payload,
  },
});

export const createMapReportDefinitionRequest = (state:IState): IState => ({
  ...state,
  mapReportDefinition: {
    ...state.mapReportDefinition,
    loading: true,
  },
});
export const createMapReportDefinitionSuccess = (
  state:IState,
  action: IAction<IGetMapReportDefinitionResponse>,
): IState => ({
  ...state,
  mapReportDefinition: {
    data: action.payload,
    loading: false,
  },
});
export const createMapReportDefinitionFail = (state:IState): IState => ({
  ...state,
  mapReportDefinition: {
    ...state.mapReportDefinition,
    loading: false,
  },
});

export const createMapReportDefinitionDefaultRequest = (state:IState): IState => ({
  ...state,
  mapReportDefinition: {
    ...state.mapReportDefinition,
    loading: true,
  },
});
export const createMapReportDefinitionDefaultSuccess = (
  state:IState,
  action: IAction<IGetMapReportDefinitionResponse>,
): IState => ({
  ...state,
  mapReportDefinition: {
    data: action.payload,
    loading: false,
  },
});
export const createMapReportDefinitionDefaultFail = (state:IState): IState => ({
  ...state,
  mapReportDefinition: {
    ...state.mapReportDefinition,
    loading: false,
  },
});

export const createZoneForMapsRequest = (state:IState): IState => ({
  ...state,
  zonesForMaps: {
    ...state.zonesForMaps,
    loading: true,
  },
});
export const createZoneForMapsSuccess = (
  state:IState,
  action: IAction<IGetZonesForMapsResponse>,
): IState => ({
  ...state,
  zonesForMaps: {
    data: action.payload,
    loading: false,
  },
});
export const createZoneForMapsFail = (state:IState): IState => ({
  ...state,
  zonesForMaps: {
    ...state.zonesForMaps,
    loading: false,
  },
});

export const createMapReportRequest = (state:IState): IState => ({
  ...state,
  mapReport: {
    ...state.mapReport,
    loading: true,
  },
});
export const createMapReportSuccess = (
  state:IState,
  action: IAction<IGetMapReportResponse>,
): IState => ({
  ...state,
  // add uniqueKey to recordsMap, because it is used as a key for map pin navigation
  mapReport: {
    data: {
      ...action?.payload,
      recordsMap: Object.fromEntries(
        Object.entries(action?.payload?.recordsMap || {}).map(([key, value]) => [
          key,
          { ...value, uniqueKey: key.replace(/[:]/g, '_') },
        ]),
      ),

    },
    loading: false,
  },
});
export const createMapReportFail = (state:IState): IState => ({
  ...state,
  mapReport: {
    ...state.mapReport,
    loading: false,
  },
});

export const updateMapControsState = (
  state:IState,
  action: IAction<IMapControlsState>,
): IState => ({
  ...state,
  mapControlsState: {
    data: action.payload,
    loading: false,
  },
});

export const updateMapControsStateFail = (state:IState): IState => ({
  ...state,
  mapControlsState: {
    ...state.mapControlsState,
    loading: false,
  },
});
